import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { LogOut, User } from 'lucide-react'
import { useAuth } from '@/contexts'
import '@/styles/pages.css'

export const Route = createFileRoute('/_app/platform/account')({
  head: () => ({ meta: [{ title: 'Account · AERRIS' }] }),
  component: AccountPage,
})

function AccountPage() {
  const { currentUser, logout } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await logout()
    navigate({ to: '/' })
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Account</h1>
          <p className="page-subtitle">Your Aerris account and session</p>
        </div>
      </div>

      <section
        className="section"
        style={{
          maxWidth: 560,
          padding: '1.5rem',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          background: 'var(--surface)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            paddingBottom: '1rem',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: 'var(--bg-page)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--accent-ink)',
            }}
          >
            <User size={22} />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: 'var(--text-primary)' }}>
              {currentUser?.name || currentUser?.email || 'Signed-in user'}
            </div>
            {currentUser?.email && (
              <div style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>
                {currentUser.email}
              </div>
            )}
          </div>
        </div>

        <div style={{ paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <button
            type="button"
            onClick={handleSignOut}
            className="btn"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 0.875rem',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-control)',
              background: 'var(--surface)',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              fontSize: '0.875rem',
              width: 'fit-content',
            }}
          >
            <LogOut size={16} />
            Sign Out
          </button>
        </div>
      </section>
    </div>
  )
}
